import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

export const companyBranchActivity = {

    namespaced: true,

    state:
    {
        ...baseStates,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters
    },
};
